<template>
    <div class="bandel-item-wrapp c-bandle-products" :class="isComda ? 'comda' : 'mlp'">
        <div class="c-bandle-products__image-wrapper">
            <button class="btn-remove" @click="removeProductFromList(product.id, productListIndex)"></button>
            <img class="c-bandle-products__img" :src="product.image" alt="">
        </div>
            <div class="c-bandle-products__title">
                {{ product.title }}
            </div>
            <div class="c-bandle-products__product-qty">
                <CustomQty
                    :modelValue="parseInt(prQty)"
                    :prIndex="productListIndex"
                    :product="product"
                    @customQtyChange="updateStoreState"
                >
                </CustomQty>
            </div>

            <div class="c-bandle-products__product-upqty-btn" v-if="false">
                <button class="c-bandle-products__btn"
                        :style="'background: ' + isComda ? '#0054a3' : '#009444'"
                        @click="updateQty"
                >
                  UPDATE QUANTITY
                </button>
            </div>
    </div>
</template>

<script>

import { store } from './store'
import CustomQty from './CustomQty.vue';

export default {
    props: {
        product: Object,
        productListIndex: Number,
        prQty: Number,
    },
    components: {
        CustomQty
    },
    data() {
        return {
            store: store
        }
    },
    computed: {
      isComda() {
        return window.location.href.includes('comda');
      },
    },
    methods: {
        removeProductFromList(id, index) {
            console.error("Before Result of removing");
            console.log(this.store.bandleProductLists);
            console.warn(id);
           // this.store.bandleProductLists = this.store.bandleProductLists.filter(item => {item.id != this.product.id});

            this.store.bandleProductLists.splice(index, 1);

            console.error("Result of removing");
            console.log(this.store.bandleProductLists);
            this.$emit("productRemoved", this.store.bandleProductLists);
        },
        updateStoreState(value) {
            console.error("updateStoreState");
            console.log(value);
            console.error("End updateStoreState");
            this.$emit("productQtyUpdated", value);
        },
        updateQty() {

        }

    },
    created() {
        console.error(">>>>>> created Product Template >>>>>>>");
        console.log(this.product);

        console.error(">>>>>>End Product Template >>>>>>>");

    },
    mounted() {
        console.error(">>>>>> mounted Product Template >>>>>>>");
    }
}


</script>

<style>
.c-bandle-products, .bandel-item-wrapp {
    display: flex;
    width: 220px;
    max-width: 220px;
    min-width: 220px;
    flex-direction: column;
    align-items: center;
}
.c-bandle-products .c-bandle-products__image-wrapper {
    display: flex;
    max-width: 175px;
    width: 175px;
    min-width: 175px;
}
.c-bandle-products .c-bandle-products__btn {
    font-family: "Montserrat", sans-serif;
    font-size: 14px;
    border-radius: 6px;
    color: #ffffff;
    padding: 6px 18px 6px;
    margin: 0;
    border: 0;
}
.c-bandle-products__title {
    font-family: 'Montserrat', sans-serif;
    line-height: 1;
    font-size: 14px;
    color: #009444;
    font-weight: normal;
    padding: 10px 5px 0 5px;
    margin-bottom: 5px;
}
.comda .c-bandle-products__title {
    font-family: 'Open Sans', 'Helvetica Neue', Verdana, Arial, sans-serif;
    line-height: 1.5;
    font-size: 12px;
    color: #0054a3;
    font-weight: 600;
    padding: 10px 5px 0 35px;
    margin-bottom: 5px;
}
.c-bandle-products__image-wrapper {
    position: relative;
}
.btn-remove {
    position: absolute;
    top: -5px;
    right: 0;
}

/*
.btn-remove:after {
    content: 'X';
    color: #009444;
    height: 20px;
    line-height: 20px;
    width: 100%;
    font-size: 10px;
    font-family: Arial, 'Montserrat', 'Helvetica Neue', Verdana, Arial, sans-serif;
    font-weight: bold;
}
*/

.btn-remove:hover {
    background-color: #39B54A;
    color: #ffffff;
}

.btn-remove:hover:after {
    color: #ffffff;
}

.btn-remove:after {
    content: "\00D7";
    color: #009444;
    height: 20px;
    /* line-height: 20px; */
    width: 100%;
    font-size: 14px;
    font-family: Arial,Montserrat,Helvetica Neue,Verdana,sans-serif;
    font-weight: 700;
}
.c-bandle-products__image-wrapper {

}
.c-bandle-products__img {
    max-width: 175px;
    max-height: 160px;
}
</style>